"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.colorToCss=(({h:e,s:s,l:o,a:r})=>`hsla(${360*e}, ${100*s}%, ${100*o}%, ${r})`);
//# sourceMappingURL=/@diez/web-sdk-common/lib/css-color.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@diez/web-sdk-common/lib/css-color.js
// module id = 216
// module chunks = 168707334958949